var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import copy from "fast-copy";
import { useEffect, useState } from "react";
import { DragDropContext } from "react-beautiful-dnd";
import RowDashlet from "./row";
export default function RowsDashlet(_a) {
    var meta = _a.meta, isNewRow = _a.isNewRow, isRemoveRow = _a.isRemoveRow, updateAfterDrag = _a.updateAfterDrag;
    var _b = useState({}), state = _b[0], setState = _b[1];
    var _c = useState({}), id2List = _c[0], setId2List = _c[1];
    useEffect(function () {
        var temp = [];
        var list = [];
        Object.values(meta).map(function (item) {
            temp["row".concat(item.id)] = item;
            list["drop".concat(item.id)] = "row".concat(item.id);
            setId2List(__assign({}, list));
            setState(__assign({}, temp));
        });
    }, [meta]);
    // Drag to other list function
    var move = function (source, destination, droppableSource, droppableDestination) {
        var sourceClone = Object.values(source);
        var destClone = Object.values(destination);
        var removed = sourceClone.splice(droppableSource.index, 1)[0];
        destClone.splice(droppableDestination.index, 0, removed);
        var result = {};
        result[id2List[droppableSource.droppableId]] = sourceClone;
        result[id2List[droppableDestination.droppableId]] = destClone;
        return result;
    };
    var getList = function (id) {
        var _a;
        var ret = (_a = state[id2List[id]]) === null || _a === void 0 ? void 0 : _a.meta;
        return ret;
    };
    var reorder = function (list, startIndex, endIndex) {
        var result = Object.values(list);
        var removed = result.splice(startIndex, 1)[0];
        result.splice(endIndex, 0, removed);
        return result;
    };
    // Drag end function
    var onDragEnd = function (result) {
        var _a;
        var source = result.source, destination = result.destination;
        // dropped outside the list
        if (!destination) {
            return;
        }
        if (source.droppableId === destination.droppableId) {
            if (source.droppableId.includes("drop")) {
                var getListValue = getList(source.droppableId);
                var ind = source.droppableId.replace("drop", "");
                var items = reorder(getListValue, source.index, destination.index);
                var newS = __assign(__assign({}, state), (_a = {}, _a["row".concat(ind)] = __assign(__assign({}, state["row".concat(ind)]), { meta: items }), _a));
                setState(newS);
                updateAfterDrag(newS);
            }
        }
        else {
            var result_1 = move(getList(source.droppableId), getList(destination.droppableId), source, destination);
            var tempRes_1 = copy(state);
            Object.entries(result_1).map(function (items, i) {
                var ind = items[0].replace("row", "");
                Object.values(state).map(function (row, index) {
                    var _a;
                    if (ind === row.id) {
                        tempRes_1 = __assign(__assign({}, tempRes_1), (_a = {}, _a[items[0]] = __assign(__assign({}, state[items[0]]), { meta: items[1] }), _a));
                    }
                });
            });
            setState(tempRes_1);
            updateAfterDrag(__assign({}, tempRes_1));
        }
    };
    // Pass add props to parents
    var newRow = function (id) {
        isNewRow(id);
    };
    // Pass remove props to parents
    var removeRow = function (id) {
        isRemoveRow(id);
    };
    return (_jsx("div", __assign({ className: "" }, { children: _jsx(DragDropContext, __assign({ onDragEnd: onDragEnd }, { children: state &&
                Object.values(state).map(function (item, i) { return (_jsx(_Fragment, { children: _jsx(RowDashlet, { dashlet: item, rowIndex: item.id, newRow: newRow, removeRow: removeRow, metaDashlet: meta }, item.id) })); }) })) })));
}
